import $ from 'jquery'
$(function () {
  function initialSubmit() {
    const submitRegist = $('#js-submit-regist');
    const submitModal = $('#js-submit-modal');
    submitModal.hide();

    let switchSubmit = function(target, triggerValue) {
      if (!target.val()) return;

      if (target.val() == triggerValue) {
        submitRegist.hide();
        submitModal.show();
      } else {
        submitRegist.show();
        submitModal.hide();
      }
    };

    let addSwitchSubmitHundler = function(radio, triggerValue) {
      radio.change(function() {
        let target = $(this);
        switchSubmit(target, triggerValue)
      });
    };

    const scheduled_zoom_event = $('input[name="hospital_adminable_programs_event_form_root[scheduled_zoom_event]"]:radio');
    addSwitchSubmitHundler(scheduled_zoom_event, 'all')

    const one_on_one_zoom_event = $('input[name="hospital_adminable_programs_event_form_root[one_on_one_zoom_event]"]:radio');
    addSwitchSubmitHundler(one_on_one_zoom_event, 'one_on_one')

    const scheduled_zoom_event_checked = $('input[name="hospital_adminable_programs_event_form_root[scheduled_zoom_event]"]:checked');
    switchSubmit(scheduled_zoom_event_checked, 'all')

    const one_on_one_zoom_event_checked = $('input[name="hospital_adminable_programs_event_form_root[one_on_one_zoom_event]"]:checked');
    switchSubmit(one_on_one_zoom_event_checked, 'one_on_one')
  }

  initialSubmit();

  $('.openModal').click(function(e){
    const target = e.currentTarget.dataset.modal;
    if (target) {
      $(`.modalArea[data-modal="${target}"]`).fadeIn();
    } else {
      $('.modalArea').fadeIn();
    }
  });
  const defaultModal = $('#display-modal').data('display')
  if (defaultModal) {
    $('.modalArea').fadeIn();
  }
  $('.closeModal , .modalBg').click(function(){
    $('.modalArea, .programModalArea').fadeOut();
  });

  // FIXME: このjsはmodal全体の話なので、以下の特異なmodalの設定は本当はココでやるべきじゃない。
  const scrollArea =  $('#js-scroll-area')
  const roomConfirm = $('.m__admin-modal--room .confirm')
  const observerOption = {
    root: document.querySelector('div#js-scroll-area'),
    rootMargin: '0px',
    threshold: 0.1
  }
  const observeTarget = document.querySelector('#observe_target')
  const observer = new IntersectionObserver((entries, _observer) => {
    // observeされたtarget全部がentriesで来るが今回は一個しかないので[0]でアクセス
    if (entries[0].isIntersecting) {
      roomConfirm.removeClass('m__admin-common__btn--disabled').addClass('active');
      roomConfirm.next('.notice').fadeOut();
      roomConfirm.one('click', () => {
        roomConfirm.addClass('finished')
        $('.m__admin-modal--room .regist').addClass('active');
  
        const roomRegist = $('.m__admin-modal--room .regist')
        roomRegist.one('click', () => {
          $('#event_form').find('form').submit();
        })
      })
    }
  }, observerOption)

  observer.observe(observeTarget);
});
